import { Grid } from "@material-ui/core";
import BeenhereIcon from "@material-ui/icons/Beenhere";
import ErrorIcon from "@material-ui/icons/Error";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import RxButton from "../../../components/RxButton";
import RxOrderDetail from "../../../components/RxOrderDetail";
import { ProductDetail } from "../../../components/RxOrderDetail/RxOrderDetail";
import RxTypography from "../../../components/RxTypography";
import api from "../../../config/AxiosConfig";
import RxPaper from "../..//../components/RxPaper";
import styles from "./PaymentResultPage.module.css";

interface PaymentResultObject {
	orderNumber: number;
	processNo: string;
	orderDate: string;
	paymentOk: boolean;
	totalPrice: number;
	products: ProductDetail[];
}

const PaymentResultPage = () => {
	const history = useHistory();

	const [paymentResult, setPaymentResult] = useState<PaymentResultObject>({
		orderNumber: -1,
	} as PaymentResultObject);

	const getPaymentResult = async () => {
		await api
			.get("/1/payment/result")
			.then((response: PaymentResultObject) => {
				if (response.orderNumber !== -1) {
					setPaymentResult(response);
				} else {
					history.push("/");
				}
			});
	};

	useEffect(() => {
		getPaymentResult();
	}, []); // eslint-disable-line

	return (
		<>
			{paymentResult.orderNumber !== -1 && (
				<RxPaper className={styles.mainPaper}>
					<Grid
						container
						spacing={1}
						direction="row"
						justifyContent="center"
						alignItems="center"
						alignContent="center"
					>
						{paymentResult.paymentOk && (
							<Grid item xs={12} sm={12}>
								<Grid container spacing={1} justifyContent="center">
									<Grid item>
										<BeenhereIcon
											className={styles.customCheckStyle}
										/>
									</Grid>
									<Grid item>
										<RxTypography
											variant="h4"
											align="center"
											label={"Ödemeniz başarı ile tamamlandı."}
											className={styles.marginTop}
										/>
									</Grid>
									<Grid item>
										<BeenhereIcon
											className={styles.customCheckStyle}
										/>
									</Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									justifyContent="center"
									className={styles.marginTopFifty}
								>
									<Grid item>
										<RxTypography
											variant="h6"
											align="center"
											component="span"
											label={"Sipariş Numaranız: "}
											className={styles.marginTopBold}
										/>
										<RxTypography
											variant="h6"
											align="center"
											component="span"
											label={paymentResult.orderNumber}
											className={styles.marginTop}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1} justifyContent="center">
									<Grid item>
										<RxTypography
											variant="h6"
											align="center"
											component="span"
											label={"İşlem Numaranız: "}
											className={styles.marginTopBold}
										/>
										<RxTypography
											variant="h6"
											align="center"
											component="span"
											label={paymentResult.processNo}
											className={styles.marginTop}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1} justifyContent="center">
									<Grid item>
										<RxTypography
											variant="h6"
											align="center"
											component="span"
											label={"Sipariş Tarihiniz: "}
											className={styles.marginTopBold}
										/>
										<RxTypography
											variant="h6"
											align="center"
											component="span"
											label={paymentResult.orderDate}
											className={styles.marginTop}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1} justifyContent="flex-start">
									<Grid item>
										<RxTypography
											variant="h6"
											align="center"
											label={"Sipariş Detayı:"}
											className={
												styles.marginTop +
												" " +
												styles.bold +
												" " +
												styles.leftMargin
											}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1} justifyContent="center">
									<Grid item>
										<RxOrderDetail
											tableClassName={styles.tableMinWidth}
											tableHeadClassName={styles.tableBackground}
											totalPrice={paymentResult.totalPrice}
											values={paymentResult.products}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1} justifyContent="center">
									<Grid item>
										<RxTypography
											variant="body1"
											align="center"
											label={
												"Sipariş detayı ve kullanım ile ilgili ayrıntılar tarafınıza e-posta olarak iletilmiştir."
											}
											className={styles.marginTop}
										/>
									</Grid>
								</Grid>
							</Grid>
						)}
						{!paymentResult.paymentOk && (
							<Grid item xs={12} sm={12}>
								<Grid container spacing={1} justifyContent="center">
									<Grid item>
										<ErrorIcon className={styles.customErrorStyle} />
									</Grid>
									<Grid item>
										<RxTypography
											variant="h4"
											align="center"
											label={
												"Ödeme sırasında hata ile karşılaşıldı."
											}
											className={styles.marginTopError}
										/>
									</Grid>
									<Grid item>
										<ErrorIcon className={styles.customErrorStyle} />
									</Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									justifyContent="center"
									className={styles.descriptionMarginTop}
								>
									<Grid item>
										<RxTypography
											variant="h6"
											align="center"
											label={
												"Ödeme işlemi sırasında hata ile karşılaşıldı. Satın alma işlemini tekrar deneyiniz."
											}
										/>
									</Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									justifyContent="center"
									className={styles.buttonMarginTop}
								>
									<Grid item>
										<RxButton
											fullWidth
											size="large"
											color={"primary"}
											variant="contained"
											label="ÖDEME İŞLEMİNİ TEKRAR DENE"
											onClick={() => {
												history.push("/payment");
											}}
										/>
									</Grid>
								</Grid>
							</Grid>
						)}
					</Grid>
				</RxPaper>
			)}
		</>
	);
};

export default PaymentResultPage;
